import {Component, Injector, OnInit} from '@angular/core';
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import {ObjectModel} from "../../../../models/ObjectModel";
import {ObjectsService} from "../../../../services/objects.service";
import {ObjectImportResult} from "../../../../models/ObjectImportResult";
import {ObjectImportModel} from "../Models/ObjectImportModel";

@Component({
    selector: 'app-objects-import-dialog',
    templateUrl: './objects-import-dialog.component.html',
    styleUrls: ['./objects-import-dialog.component.css'],
    standalone: false
})
export class ObjectsImportDialogComponent extends DialogBaseComponent<ObjectImportModel> implements OnInit {
  protected objectsService: ObjectsService;

  ImportFailedMsg = this.translate.instant("Import failed");
  ImportSuccessMsg = this.translate.instant("Imported");
  ImeiConflictMsg = this.translate.instant("IMEI duplicates");
  ObjectConflictMsg = this.translate.instant("Import error");

  constructor(protected injector: Injector) {
    super(injector);
    this.objectsService = injector.get(ObjectsService);
    this.dialogId = "objectImport";
  }


  ngOnInit() {
    super.ngOnInit();
  }

/*  show(id: number) {
    this.objectsService.GetObject(id)
      .subscribe(object => {
        this.objectsService.GetIcons()
          .subscribe((icons: IconViewModel[]) => {
            this.objectsService.GetOdometer(object.Id)
              .subscribe(odometer => {
                object.Icon = icons.find(i => i.Id == object.IconId);
                object.Odometer = odometer;
                this.open(object);
              })
          })
      });
  }*/

  public submit() {
    if (this.model.Content) {
      this.objectsService.importFromFile(this.model)
        .subscribe({
          next: (response: ObjectImportResult) => {
            if (response.SuccessCount > 0)
              this.toastr.success(`${this.ImportSuccessMsg}: ${response.SuccessCount}`);
            if (response.ConflictImeis.length > 0)
              this.toastr.error(`${this.ImeiConflictMsg}: ${response.ConflictImeis.length}`);
            if (response.ConflictObjectNames.length > 0)
              this.toastr.error(`${this.ObjectConflictMsg}: ${response.ConflictObjectNames.length}`);
            this.close();
            super.submit();
          },
          error: () => {
            this.toastr.error(this.ImportFailedMsg);
          }
        });
    }
    else {
      this.toastr.error(this.translate.instant('The file field is required'));
      return;
    }
  }
}
